import React from 'react';
import { CheckIcon, XIcon, AlertTriangleIcon } from 'lucide-react';
interface Subscription {
  type: string;
  status: string;
  expiryDate: Date;
  features: string[];
  restrictions: string[];
}
interface SubscriptionCardProps {
  subscription: Subscription;
}
export function SubscriptionCard({
  subscription
}: SubscriptionCardProps) {
  const daysLeft = Math.ceil((subscription.expiryDate.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
  return <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-274">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-275">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-276">Mon abonnement</h2>
      </div>
      <div className="px-6 py-4" data-id="element-277">
        <div className="flex items-center justify-between mb-4" data-id="element-278">
          <div data-id="element-279">
            <span className="text-sm font-medium text-gray-500" data-id="element-280">Type</span>
            <div className="text-xl font-semibold text-blue-900" data-id="element-281">
              {subscription.type}
            </div>
          </div>
          <div className="bg-green-100 text-green-800 text-sm font-medium px-3 py-1 rounded-full" data-id="element-282">
            {subscription.status}
          </div>
        </div>
        <div className="mb-6" data-id="element-283">
          <div className="text-sm font-medium text-gray-500 mb-1" data-id="element-284">
            Expire dans
          </div>
          <div className="flex items-center" data-id="element-285">
            <div className="text-2xl font-bold text-blue-900" data-id="element-286">{daysLeft}</div>
            <div className="ml-1 text-gray-700" data-id="element-287">jours</div>
          </div>
          <div className="mt-2 h-2 bg-gray-200 rounded-full" data-id="element-288">
            <div className="h-full bg-yellow-500 rounded-full" style={{
            width: `${daysLeft / 7 * 100}%`
          }} data-id="element-289"></div>
          </div>
        </div>
        {/* Alert for trial expiration */}
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6" data-id="element-290">
          <div className="flex" data-id="element-291">
            <div className="flex-shrink-0" data-id="element-292">
              <AlertTriangleIcon className="h-5 w-5 text-yellow-400" data-id="element-293" />
            </div>
            <div className="ml-3" data-id="element-294">
              <p className="text-sm text-yellow-700" data-id="element-295">
                Votre période d'essai se termine bientôt. Passez à un forfait
                premium pour continuer à bénéficier de tous les avantages.
              </p>
            </div>
          </div>
        </div>
        {/* Features */}
        <div className="mb-6" data-id="element-296">
          <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-297">
            Inclus dans votre abonnement
          </h3>
          <ul className="space-y-2" data-id="element-298">
            {subscription.features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-299">
                <div className="flex-shrink-0 h-5 w-5 text-green-500" data-id="element-300">
                  <CheckIcon size={20} data-id="element-301" />
                </div>
                <p className="ml-2 text-sm text-gray-600" data-id="element-302">{feature}</p>
              </li>)}
          </ul>
        </div>
        {/* Restrictions */}
        <div className="mb-6" data-id="element-303">
          <h3 className="text-sm font-medium text-gray-900 mb-3" data-id="element-304">
            Limitations
          </h3>
          <ul className="space-y-2" data-id="element-305">
            {subscription.restrictions.map((restriction, index) => <li key={index} className="flex items-start" data-id="element-306">
                <div className="flex-shrink-0 h-5 w-5 text-red-500" data-id="element-307">
                  <XIcon size={20} data-id="element-308" />
                </div>
                <p className="ml-2 text-sm text-gray-600" data-id="element-309">{restriction}</p>
              </li>)}
          </ul>
        </div>
        <div className="pt-4 border-t border-gray-200" data-id="element-310">
          <button className="w-full bg-blue-900 hover:bg-blue-800 text-white font-medium py-2 px-4 rounded-lg shadow-sm" data-id="element-311">
            Passer au Premium
          </button>
          <a href="#" className="mt-3 block text-center text-sm text-blue-600 hover:text-blue-800" data-id="element-312">
            Voir tous les forfaits
          </a>
        </div>
      </div>
    </div>;
}